import React from "react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 py-12 sm:py-14 md:py-16 grid grid-cols-12 gap-y-8 md:gap-10">
        <div className="col-span-12 md:col-span-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 border border-[#D4AF37]/50 flex items-center justify-center">
              <span className="font-display text-[#D4AF37] text-xl leading-none">C</span>
            </div>
            <div className="leading-none">
              <div className="font-display text-xl tracking-wide text-white">CarSpa</div>
              <div className="text-[10px] tracking-[0.3em] sm:tracking-[0.35em] uppercase text-[#D4AF37]/80">
                Prémiový Detailing
              </div>
            </div>
          </div>
          <p className="mt-5 sm:mt-6 text-sm text-zinc-400 font-light leading-relaxed max-w-sm">
            Prémiový detailing od roku 2014. Dvě pobočky v Praze — Čestlice a Butovice —
            a rostoucí síť. Chemie Koch, Gyeon, Swiss Wax.
          </p>
          <a
            href="https://wa.me/420732434878"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            className="mt-5 inline-flex items-center gap-2 text-sm text-[#25D366] hover:text-[#5EE694] transition-colors"
          >
            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden>
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
            </svg>
            <span className="tracking-wide">WhatsApp · 732 434 878</span>
          </a>
        </div>

        <div className="col-span-6 md:col-span-2">
          <div className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-5">Navigace</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li><a href="#pribeh" className="lux-link hover:text-[#D4AF37]">Příběh</a></li>
            <li><a href="#nabidka" className="lux-link hover:text-[#D4AF37]">Balíčky</a></li>
            <li><a href="#pobocky" className="lux-link hover:text-[#D4AF37]">Pobočky</a></li>
            <li><a href="#faq" className="lux-link hover:text-[#D4AF37]">FAQ</a></li>
            <li><a href="#rezervace" className="lux-link hover:text-[#D4AF37]">Rezervace</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-5">Čestlice</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Pražská 138, Aquapalace</li>
            <li><a href="tel:+420730595595" className="lux-link hover:text-[#D4AF37]">730 595 595</a></li>
            <li className="text-zinc-500">Po–Pá 8:00 – 19:00</li>
          </ul>
          <div className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-5 mt-8">Butovice</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>Coral Office Park, Nové Butovice</li>
            <li><a href="tel:+420732327777" className="lux-link hover:text-[#D4AF37]">732 327 777</a></li>
            <li className="text-zinc-500">Po–Pá 8:00 – 19:00</li>
          </ul>
        </div>

        <div className="col-span-12 md:col-span-3">
          <div className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-5">Provozovatel</div>
          <ul className="space-y-2 text-sm text-zinc-400 leading-relaxed">
            <li className="text-white">Rimedio delta s.r.o.</li>
            <li>IČO <span className="text-zinc-300">02353431</span></li>
            <li>DIČ <span className="text-zinc-300">CZ02353431</span></li>
            <li>Chudenická 1059/30</li>
            <li>Hostivař, 102 00 Praha 10</li>
            <li className="text-[11px] text-zinc-500 pt-2 leading-snug">
              Zapsáno v OR u Městského soudu v Praze
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 py-5 sm:py-6 flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4 text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-zinc-500">
          <div className="text-center md:text-left">© {new Date().getFullYear()} CarSpa · Rimedio delta s.r.o. · Všechna práva vyhrazena</div>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-6">
            <a href="/admin/login" className="lux-link hover:text-[#D4AF37]">Admin</a>
            <a href="#" className="lux-link hover:text-[#D4AF37]">Obchodní podmínky</a>
            <a href="#" className="lux-link hover:text-[#D4AF37]">Ochrana údajů</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
